"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoommateInterestCategoryEntity = exports.RoommateInterestOptionEntity = exports.RoommateInterestEntity = void 0;
var RoommateInterestEntity = /** @class */ (function () {
    function RoommateInterestEntity() {
        this.id = '';
        this.inputTypeId = '';
        this.roommateInterestCategoryId = '';
        this.question = '';
        this.isRequired = false;
        this.writtenResponse = '';
        this.isShow = false;
        this.optionDetails = [];
        this.customerOptionIds = '';
        this.customerResponse = '';
    }
    return RoommateInterestEntity;
}());
exports.RoommateInterestEntity = RoommateInterestEntity;
var RoommateInterestOptionEntity = /** @class */ (function () {
    function RoommateInterestOptionEntity() {
        this.id = '';
        this.title = '';
        this.isSelected = false;
    }
    return RoommateInterestOptionEntity;
}());
exports.RoommateInterestOptionEntity = RoommateInterestOptionEntity;
var RoommateInterestCategoryEntity = /** @class */ (function () {
    function RoommateInterestCategoryEntity() {
        this.id = '';
        this.name = '';
    }
    return RoommateInterestCategoryEntity;
}());
exports.RoommateInterestCategoryEntity = RoommateInterestCategoryEntity;
